import { render, staticRenderFns } from "./indexLoadCohort.vue?vue&type=template&id=3aa5def2&"
import script from "./indexLoadCohort.vue?vue&type=script&lang=js&"
export * from "./indexLoadCohort.vue?vue&type=script&lang=js&"
import style0 from "./indexLoadCohort.vue?vue&type=style&index=0&id=3aa5def2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports